import { XML_REPORT_TYPES_LIST } from "../../../data/accounting-constants";

// Master config constants
export const INITIAL_ROW_LABEL_INFO = {
  [XML_REPORT_TYPES_LIST[0].value]: {
    'Sales Cost Center': '',
    'Sales Voucher Name': '',
    'Settlement Cost Center': '',
    'Settlement Voucher Name': '',
  },
  [XML_REPORT_TYPES_LIST[1].value]: {
    'Purchase Voucher Name': '',
    'Purchase Cost Center': ''
  }
};

export const MASTER_CONFIG_COLS_CONFIG = {
    [XML_REPORT_TYPES_LIST[0].value]: [
      { label: "Sales Voucher Name", width: "19%", key: "Sales Voucher Name" },
      {
        label: "Settlement Voucher Name",
        width: "19%",
        key: "Settlement Voucher Name",
      },
      { label: "Sales Cost Center", width: "18%", key: "Sales Cost Center" },
      {
        label: "Settlement Cost Center",
        width: "21%",
        key: "Settlement Cost Center",
      },
    ],
    [XML_REPORT_TYPES_LIST[1].value]: [
      {
        label: "Purchase Voucher Name",
        width: "38.5%",
        key: "Purchase Voucher Name",
      },
      {
        label: "Purchase Cost Center",
        width: "38.5%",
        key: "Purchase Cost Center",
      },
    ],
  };

  // Ledger Config constants
  export const LEDGER_CONFIG_COLS = {
    MASTER_KEY: "type",
    RISTA_DATA: "ristaData",
    TALLY_DATA: "tallyData",
  }

  export const LEDGER_CONFIG_COLS_CONFIG = [
    {
      label: "Type",
      width: "24%",
      key: LEDGER_CONFIG_COLS.MASTER_KEY,
      getClassName: (isUnmapped: boolean) =>
        `${
          isUnmapped ? "bg-[#FFEBEB]" : "bg-[#EAF1FE]"
        } text-black font-semibold text-16 border-r-[1px] px-40`,
    },
    {
      label: "Rista",
      width: "37%",
      key: LEDGER_CONFIG_COLS.RISTA_DATA,
      className: "pl-40 pr-0 ",
    },
    {
      label: "Tally",
      width: "37%",
      key: LEDGER_CONFIG_COLS.TALLY_DATA,
      className: "pr-40 pl-0 ",
    },
  ];